"use client";

import { useQuery } from "@apollo/client";
import { Button, Card, Group, Stack } from "@mantine/core";
import Link from "next/link";
import { formatYen } from "@/app/(logedIn)/mypage/rewards/_function/kyashTransfer";
import { kyashTransferSummaryQuery } from "@/app/(logedIn)/mypage/rewards/_graphql";
import { Loader, Text } from "@/components/ui/elements";
import { gradientTextStyle } from "./_function/workReward";

/**
 * 獲得報酬の申請可能額と同じクエリで取得し、キャッシュの形を揃える。
 * 取得に失敗しても、獲得報酬の画面で取り直せるためボタンは押せるままにする。
 */
export function KyashBalanceCard() {
  const { data, loading, error } = useQuery(kyashTransferSummaryQuery, {
    fetchPolicy: "network-only",
  });
  const summary = data?.kyashTransferSummary;

  const renderAmount = () => {
    if (loading && !summary) return <Loader size="sm" color="teal" />;
    if (error || !summary) {
      return (
        <Text fz="xs" c="gray.6">
          取得できませんでした
        </Text>
      );
    }
    return (
      <Text fz={{ base: 24, sm: 28 }} fw="bold" style={gradientTextStyle.teal}>
        {formatYen(summary.availableAmount)}
      </Text>
    );
  };

  return (
    <Card
      withBorder
      p="sm"
      radius="lg"
      style={{
        background: "linear-gradient(135deg, #f0fdfa 0%, #f8fafc 100%)",
        border: "1px solid #ccfbf1",
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap" gap="sm">
        <Stack gap={2}>
          <Text fw="bold" fz="sm" c="dark.7">
            給与残高
          </Text>
          {/* 取得中・失敗時も金額と同じ高さを保ち、下のカードの位置がずれないようにする */}
          <Group mih={{ base: 38, sm: 44 }} align="center">
            {renderAmount()}
          </Group>
        </Stack>
        <Button
          component={Link}
          href="/mypage/rewards"
          color="teal"
          radius="xl"
        >
          引き出す
        </Button>
      </Group>
    </Card>
  );
}
